import React from "react";
import { Link } from "react-router-dom";
import { Lightbulb, ArrowRight } from "lucide-react";

export const RequestManual = () => {
  return (
    <section data-testid="request-manual" className="max-w-5xl mx-auto px-6 md:px-12 py-10 md:py-14">
      <div className="bg-blue-50 border-2 border-blue-100 rounded-2xl p-8 md:p-12 flex flex-col md:flex-row md:items-center gap-8 text-center md:text-left">
        <span className="bg-white text-[#0056D2] rounded-2xl p-5 self-center md:self-start shrink-0">
          <Lightbulb size={48} strokeWidth={2} />
        </span>
        <div className="flex-1">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#1A1A1A]">Saknar du en manual?</h2>
          <p className="text-lg md:text-xl text-[#4A4A4A] mt-3 leading-relaxed">
            Hittar du inte guiden du letar efter? Kontakta oss och berätta vad du behöver hjälp med,
            så skapar vi en enkel och pedagogisk manual åt dig!
          </p>
        </div>
        <Link
          to="/kontakt"
          data-testid="request-manual-btn"
          className="inline-flex items-center justify-center gap-3 min-h-[64px] px-8 bg-[#0056D2] text-white text-xl font-bold rounded-lg hover:bg-[#003E99] transition-colors whitespace-nowrap self-center"
        >
          Önska en manual <ArrowRight size={26} strokeWidth={2.5} />
        </Link>
      </div>
    </section>
  );
};
